<app-alleviate-nausea-and-vomiting htmlTitle="<strong>Important: Prevent</strong> Nausea & Stay on Track With Your TRT">
  <ng-content>
    <p class="mb-4">
      One common and uncomfortable side effect when starting or adjusting testosterone therapy is nausea. Fortunately,
      there’s a trusted solution: <strong>Zofran (Ondansetron)</strong>.
    </p>
    <p class="mb-4">
      By adding <strong>Zofran</strong> to your treatment plan, you can help ensure a smoother, more comfortable
      experience if nausea occurs—so you can stay consistent and avoid missed doses.
    </p>
    <p class="mb-4">
      This option includes a supply of <strong>15 pills</strong>. Zofran is
      <strong>shelf-stable for up to 2 years</strong> and can be stored in your medicine cabinet.
    </p>
  </ng-content>
</app-alleviate-nausea-and-vomiting>
